export * from './nosocial.component';
